import * as Bounce from './Bounce';
import * as Breathe from './Breathe';
// import * as Blink from './Blink';
import * as Cross from './Cross';
// import * as DVD from './DVD';
import * as Flash from './Flash';
import * as Flip from './Flip';
import * as Fold from './Fold';
import * as Jello from './Jello';
import * as Poke from './Poke';
import * as Rubber from './Rubber';
import * as Pulse from './Pulse';
import * as Spin from './Spin';
import * as Swing from './Swing';
import * as Wiggle from './Wiggle';
export const ongoingAnimations = {
  Bounce,
  Breathe,
  // Blink,
  Cross,
  // DVD,
  Flash,
  Flip,
  Fold,
  Jello,
  Poke,
  Rubber,
  Pulse,
  Spin,
  Swing,
  Wiggle
};
//# sourceMappingURL=index.js.map